<div class="session-expired-dialog">

  <div class="session-expired-icon-wrapper">
    <mat-icon class="session-expired-icon">error_outline</mat-icon>
  </div>

  <h2 class="session-expired-title">{{ data.title }}</h2>
  <p class="session-expired-message">{{ data.messageString }}</p>

  <p class="session-expired-countdown">Redirecting in {{ countdown }}s...</p>

  <mat-dialog-actions align="center">
    <button mat-raised-button color="primary" [mat-dialog-close]="" cdkFocusInitial>
      Sign In
    </button>
  </mat-dialog-actions>

</div>
